import React, { useContext, useEffect, useState } from "react";
import { Title } from "../../../../../stories/Title/Title";
import Close from "../../../../../images/Close.svg";
import Delete from "../../../../../images/Delete.svg";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GetMobileDevicesDetails } from "./queries/queries";
import {
  DeleteMobileDeviceResult,
  DeleteMobileDeviceVar,
  GetMobileDevicesDetailsResult,
  GetMobileDevicesDetailsVar,
} from "./queries/types";
import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import { AppContext } from "../../../../../context/context";
import {
  EMPTY_STRING,
  ROWS_PER_PAGE,
  UserType,
} from "../../../../../utils/constants";
import MobileDevice from "../../../../../images/Installed_Devices.svg";
import { EmpMaster, EmpMasterOrderField, EmpQueryType } from "../queries/types";
import { GetEmp, GetEmpMasterByNodeId } from "../queries/queries";
import { OrderDirection, nodeVar } from "../../../../../utils/commonQueryTypes";
import { TextField } from "@mui/material";
import { Operation, empType } from "../../../../../utils/Enum.types";
import { DeleteMobileDevice } from "./queries/mutation";
import MessageModal from "../../../../../customComponents/MessageModal";
import LoadingModal from "../../../../pages/LoadingModal";

interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}

const DeviceDetails = ({ setModalFlag }: Props) => {
  const { customer_id } = useUrlParams();
  const { user_details } = useLoggedInUserDetails();
  const { state } = useContext(AppContext);
  const [message, setMessage] = useState({
    message: EMPTY_STRING,
    flag: false,
    operation: Operation.NONE,
  });

  const [GetMobileDetails, { data: MobileData }] = useLazyQuery<
    GetMobileDevicesDetailsResult,
    GetMobileDevicesDetailsVar
  >(GetMobileDevicesDetails);

  const [GetEmpById, { data: empData, loading: GetEmpMasterByNodeIdLoading }] =
    useLazyQuery<{ node: EmpMaster }, nodeVar>(GetEmpMasterByNodeId);

  const [deleteMobileDevice, { loading: DeleteMobileDeviceLoading }] =
    useMutation<DeleteMobileDeviceResult, DeleteMobileDeviceVar>(
      DeleteMobileDevice,
      {
        onError: (e) => {
          setMessage({
            message: e.message,
            flag: true,
            operation: Operation.NONE,
          });
        },
      }
    );

  useEffect(() => {
    if (customer_id && state.empId) {
      GetMobileDetails({
        variables: {
          customerID: customer_id,
          user_details: {
            user_type: UserType.EMPLOYEE,
            id: state.empId,
          },
        },
      });
    }
  }, [GetMobileDetails, customer_id, state.empId]);

  useEffect(() => {
    if (state.empId)
      GetEmpById({
        variables: {
          id: state.empId,
        },
      });
  }, [GetEmpById, state.empId]);

  const handleDelete = (deviceID: number) => {
    if (customer_id && state.empId)
      deleteMobileDevice({
        variables: {
          customerID: customer_id,
          deviceID: Number(deviceID),
          user_details,
        },
        refetchQueries: [
          {
            query: GetMobileDevicesDetails,
            variables: {
              customerID: customer_id,
              user_details: {
                user_type: UserType.EMPLOYEE,
                id: state.empId,
              },
            },
          },
          {
            query: GetEmp,
            variables: {
              after: null,
              customer_id,
              first: ROWS_PER_PAGE,
              input: {
                queryType: EmpQueryType.ALL,
                empType: [empType.DCP],
                companyID: state.companyId ? state.companyId : 0,
                ldgrID: 0,
                siteID: state.subSiteId ? state.subSiteId : 0,
                subsidiaryID: state.subsidiaryId ? state.subsidiaryId : 0,
              },
              orderBy: {
                direction: OrderDirection.ASC,
                field: EmpMasterOrderField.NAME,
              },
              name: EMPTY_STRING,           
            },
          },
        ],
      });
  };

  return (
    <>
      <div className="assign-supplier">
        <div className="assign-supplier__title">
          <Title>Individual User Device Details</Title>
          <img src={Close} alt="" onClick={() => setModalFlag(false)} />
        </div>
        {empData && empData.node && (
          <div className="row">
            <div className="col-4">
              <TextField
                label="Name"
                slotProps={{
                  inputLabel: {
                    shrink: true,
                  },
                }}
                disabled
                value={empData.node.name}
                className="assign-user-rights__textfield"
              />
            </div>
            <div className="col-4">
              <TextField
                label="Email"
                slotProps={{
                  inputLabel: {
                    shrink: true,
                  },
                }}
                disabled
                value={empData.node.email}
                className="assign-user-rights__textfield"
              />
            </div>
            <div className="col-4">
              <TextField
                label="Emp Type"
                slotProps={{
                  inputLabel: {
                    shrink: true,
                  },
                }}
                disabled
                value={empData.node.empType}
                className="assign-user-rights__textfield"
              />
            </div>
            <div className="col-4">
              <TextField
                label="Mobile"
                slotProps={{
                  inputLabel: {
                    shrink: true,
                  },
                }}
                disabled
                value={empData.node.mobile}
                className="assign-user-rights__textfield"
              />
            </div>
            <div className="col-4">
              <TextField
                label="KGID"
                slotProps={{
                  inputLabel: {
                    shrink: true,
                  },
                }}
                disabled
                value={empData.node.kgid}
                className="assign-user-rights__textfield"
              />
            </div>
          </div>
        )}

        <div className="std-device-details__drawer--total">
          <span>Total Devices Logged in </span>
          <div className="std-device-details__drawer--total--t">
            {/* <b>{deviceNo}</b> */}
          </div>
        </div>
        <ul className="std-device-details__drawer--ul">
          {MobileData
            ? MobileData.GetMobileDevicesDetails.map(
                (data: any, index: React.Key) => {
                  const dateObj = new Date(data.lastLoginDate);
                  const isoTime = dateObj
                    .toISOString()
                    .split("T")[1]
                    .split(".")[0];
                  const date = dateObj.toLocaleDateString();

                  return (
                    <li
                      key={index}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <img src={MobileDevice} alt="" /> <b>{data.brand}</b>
                        &nbsp;
                        <span>{data.model}</span>
                      </div>

                      <b>
                        Last accessed :- {isoTime} {date}
                      </b>
                      <div>
                        <img
                          src={Delete}
                          alt=""
                          onClick={() => {
                            handleDelete(data.deviceID);
                          }}
                        />
                      </div>
                    </li>
                  );
                }
              )
            : EMPTY_STRING}
        </ul>
      </div>
      <MessageModal
        modalFlag={message.flag!}
        value={message.message!}
        handleClose={() =>
          setMessage({
            flag: false,
            message: "",
            operation: Operation.NONE,
          })
        }
        operation={message.operation!}
      />
      <LoadingModal
        flag={
          GetEmpMasterByNodeIdLoading ||
          DeleteMobileDeviceLoading ||
          DeleteMobileDeviceLoading
        }
      />
    </>
  );
};

export default DeviceDetails;
